import { render, staticRenderFns } from "./KeysJournalItem.vue?vue&type=template&id=ed1c9022&"
import script from "./KeysJournalItem.vue?vue&type=script&lang=js&"
export * from "./KeysJournalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports